/* eslint-disable prefer-const */
import {
  customersAuthorizationApi,
  ECustomerAuthorizationEndpoints
} from '../api';
import { EGerdauService } from '../EGerdauService';
import {
  ManifestationDataProps,
  ManifestationResponseProps
} from '../../store/ducks/manifestations/types';
import moment from 'moment';
import { phoneMask } from '../../utils/formatStrings';
import { formatDate } from '../../utils/formatDate';

export class Manifestation extends EGerdauService {
  async getManifestation(
    customerId: string
  ): Promise<ManifestationDataProps[]> {
    const headers = super.getHeaders();
    const response = await customersAuthorizationApi.get(
      `${ECustomerAuthorizationEndpoints.MANIFESTATIONS}?customer=${customerId}`,
      { headers }
    );

    function convertDateTime({
      value,
      type
    }: {
      value?: string;
      type: 'date' | 'time';
    }) {
      if (moment(value).isValid()) {
        if (type === 'date') {
          return formatDate(moment(value).format('YYYY-MM-DD'), 'DD/MM/YYYY');
        }
        return moment(value).format('HH:mm:ss');
      }
      return '-';
    }

    const stringValidate = (data?: string) => {
      if (!data || data?.length === 0) {
        return '-';
      }
      return data;
    };

    const convertData = response?.data?.map(
      (item: ManifestationResponseProps) => ({
        key: stringValidate(item?.id),
        orderNumber: stringValidate(item?.number),
        orderCreatedDate: convertDateTime({
          value: item?.created_at,
          type: 'date'
        }),
        orderCreatedTime: convertDateTime({
          value: item?.created_at,
          type: 'time'
        }),
        contactName: stringValidate(item?.contact?.name),
        contactPhone: phoneMask(item?.contact?.phone),
        sellerName: stringValidate(item?.representative?.name),
        vehicleOnSite: stringValidate(
          item?.is_transport_at_location ? 'Sim' : 'Não'
        ),
        manifestationDetails: stringValidate(item?.reason?.description),
        occurrence: stringValidate(item?.reason?.incident),
        status: stringValidate(item?.status),
        deniedCause: stringValidate(item?.reason?.cause)
      })
    );

    return convertData;
  }
}
